import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import './LinkCheck.scss'
import { useRecoilValue } from 'recoil'
import { messageState } from 'Pages/OverviewMessage/recoil/state/message'
import { IconInfo, Link, LINK_VARIANT_EXTRALIGHT } from 'mailup-web-components'

const LinkCheck = () => {
  const intl = useIntl()
  const history = useHistory()

  const { id: idMessage } = useRecoilValue(messageState)

  const redirectEmailCheckUp = () => {
    const route = `/messages/email/${idMessage}/checkup/linkcheck`
    history.push(route)
  }

  return (
    <div className='c-link-issue-modal'>
      <IconInfo className='c-link-issue-modal--info' />
      <h4 className='c-link-issue-modal__title'>
        {intl.formatMessage({
          id: 'Load.EmailCheckUp.LinkCheck'
        })}
      </h4>
      <p>
        {intl.formatMessage(
          {
            id: 'Load.EmailCheckUp.LinkCheckDescrIntl'
          },
          {
            link: content => (
              <Link
                variant={LINK_VARIANT_EXTRALIGHT}
                key={content}
                onClick={redirectEmailCheckUp}
              >
                {content}
              </Link>
            )
          }
        )}
      </p>
    </div>
  )
}

export default LinkCheck
